import React, { useMemo, useRef, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "emotion-theming";

import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { NewAddressContext } from "wrapper/NewAddressWrapper/context/newAddressContext";
import { AddressContext } from "wrapper/AddressWrapper/context/addressContext";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { CommonContextContext } from "wrapper/CommonWrapper/context";

import { Main, AddressFormStyle, Wrapper, HorizonalSeprator } from "./assets/style";
import {
  SubtitleWrapper,
  ButtonWrapper,
  BottomSheetWrapper,
  TrustNote,
  IconWrapper,
  ToastLayout,
  NewBottomSheetWrapper
} from "./components/PincodeBottomSheet/assets/style";
import { NewFormStyle } from "./assets/newForm";

import { Image } from "@nykaa/payment-ui/src/Image";
import { SubTitle } from "@nykaa/payment-ui/src/SubTitle";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";
import { BottomSheet } from "@nykaa/payment-ui/src/BottomSheet/BottomSheet/index";
import { BottomSheet as BackFrictionBottomSheet } from "@nykaa/payment-ui/src/BottomSheet/BottomSheet1";

import { ContainedButton, FilledButton } from "@nykaa/payment-ui/src/Button";
import { InputField, TextAreaField } from "@nykaa/payment-ui/src/InputField";
import { Title } from "@nykaa/payment-ui/src/Title";

import { PincodeBottomSheetContent } from "./components/PincodeBottomSheet";
import { MsgCard } from "components/MsgCard";
import { ToggleSwitch } from "components/ToggleSwitch";
import { OverlayLoader } from "components/OverlayLoader";
import { SelectedAddressLoader } from "layouts/CheckoutPayment/mobile/ShippingAddress/common/selectedAddressLoader";
import { BasicButtonWithIcon } from "components/Buttons/BorderButton";

import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getPlatform } from "../../helpers/index";
import { LockIcon } from "./assets/icons";

import { FORM_FIELD, FORM_FIELD_PLACEHOLDER, NEW_ADDRESS_DEFAULT_MESSAGE } from "constants/address";
import MobHeader from "components/NewMobHeader";
import { getBackFrictionData } from "logics/src/utils/getBackFrictionData";
import { trackAddressBackFrictionLoads, trackCancelPaymentClick, trackContinuewithPaymentClick } from "layouts/Payment/common/dependencies/tracking";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { TRACKING_EVENTS } from "../../constants";
import { getStorageData, setStorage } from "helpers/utils/storage";
import DetectedCity from "./components/DetectedCity";
import { Text } from "@nykaa/payment-ui/src/Text";
import { CheckBox } from "components/CheckBox";
import { Icon } from "@nykaa/payment-ui/src/Icon";
import { isServer } from "helpers/utils/isServer";
import Toast from "@nykaa/ui-components/Toast";
import { AddressPaymentSection } from "layouts/AddressPaymentSection";
import { doCheckPaymentFromAddressPageExpEnable } from "wrapper/ExperimentAndSwitchWrapper/helpers";


const NewAddress = () => {
  const theme: Theme = useTheme();
  const history = useHistory();
  const newAddressContext: any = useContext(NewAddressContext);
  const addressContext = useContext(AddressContext);
  const applicationContext = useContext(ApplicationContext);
  const {
    AddressPageBackFriction,
    AddressPageBackFrictionWithSession,
    NewAddressDesignExp,
    PaymentFormAddressPage,
  } = useContext(ExperimentAndSwitchContext);
  const { paymentInfo, orderAmount, cartInfo } = useContext(CommonContextContext);

  const platform = getPlatform();
  const CloseCircleIcon = getIcons(platform, ICONS_NAMES.CLEAR);

  const areaRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);

  const hideEmail = newAddressContext?.hideEmail;
  const headerTitle = newAddressContext?.headerTitle;
  const submitButtonTitle = newAddressContext?.submitButtonTitle;
  const genericMessage = newAddressContext?.genericMessage;
  const genericMessageType = newAddressContext?.genericMessageType;
  const addressForm = newAddressContext?.addressForm;
  const isEditing = newAddressContext?.isEditing;
  const formError = newAddressContext?.formError;
  const isLoading = newAddressContext?.isLoading;
  const isBottomSheetVisible = newAddressContext?.isBottomSheetVisible;
  const isAutoDetectLocationEnabled = newAddressContext?.isAutoDetectLocationEnabled;
  const isAutoDetectLocationBottomSheetEnabled = newAddressContext?.isAutoDetectLocationBottomSheetEnabled;
  const isImportAddressEnabled = newAddressContext?.isImportAddressEnabled;
  const showImportAddressBottomSheet = newAddressContext?.showImportAddressBottomSheet;
  const isNewAddressDesignEnabled = NewAddressDesignExp.experimentEnabled;
  const isGuestUser = newAddressContext?.isGuestUser;
  const vernacularMessages = newAddressContext?.vernacularMessages;
  const isPincodeBottomSheetVisible = newAddressContext?.isPincodeBottomSheetVisible;
  const pincodeBottomSheetTitle = newAddressContext?.pincodeBottomSheetTitle;
  const pincodeBottomSheetSubTitle = newAddressContext?.pincodeBottomSheetSubTitle;
  const pincodeBottomSheetActionButtonText = newAddressContext?.pincodeBottomSheetActionButtonText;
  const isUserEditingPincode = newAddressContext?.isUserEditingPincode;
  const fetchingGeoLocation = newAddressContext?.fetchingGeoLocation;
  const errorFetchingGeoLocation = newAddressContext?.errorFetchingGeoLocation;
  const nameInputIcon = newAddressContext?.nameInputIcon;
  const phoneInputIcon = newAddressContext?.phoneInputIcon;
  const emailInputIcon = newAddressContext?.emailInputIcon;
  const getCurrentGeoLocation = newAddressContext?.getCurrentGeoLocation;
  const handleInputChange = newAddressContext?.handleInputChange;
  const handleDefaultAddressToggle = newAddressContext?.handleDefaultAddressToggle;
  const handlePinCodeBlur = newAddressContext?.handlePinCodeBlur;
  const handleInputBlur = newAddressContext?.handleInputBlur;
  const handleBackButton = newAddressContext?.handleBackButton;
  const onSubmit = newAddressContext?.onSubmit;
  const handleDontSaveClick = newAddressContext?.handleDontSaveClick;
  const handleCloseBottomModal = newAddressContext?.handleCloseBottomModal;
  const handleSaveChangesClick = newAddressContext?.handleSaveChangesClick;
  const onPincodeBottomSheetClose = newAddressContext?.onPincodeBottomSheetClose;
  const nameInputIconVisible = newAddressContext?.nameInputIconVisible;
  const phoneInputIconVisible = newAddressContext?.phoneInputIconVisible;
  const emailInputIconVisible = newAddressContext?.emailInputIconVisible;
  const clearPhoneInputField = newAddressContext?.clearPhoneInputField;
  const clearInputField = newAddressContext?.clearInputField;
  const clearEmailInputField = newAddressContext?.clearEmailInputField;
  const showPermissionToast = newAddressContext?.showPermissionToast;
  const setShowPermissionToast = newAddressContext?.setShowPermissionToast;

  // Exp: Bottom sheet detects address by itself first and then gives user Confirm/Edit button
  const autoDetectBottomSheetSubtitle = newAddressContext?.autoDetectBottomSheetSubtitle;
  const showAutoDetectBottomSheet = newAddressContext?.showAutoDetectBottomSheet;
  const handleCloseAutoDetectBottomSheet = newAddressContext?.handleCloseAutoDetectBottomSheet;
  const handleSuccessAutoDetectBottomSheet = newAddressContext?.handleSuccessAutoDetectBottomSheet;

  // Exp: Bottom sheet gives user Auto Detect/Fill Address Manually button
  const showNewDetectLocationBottomSheet = newAddressContext?.showNewDetectLocationBottomSheet;
  const handleCloseNewAutoDetectBottomSheet = newAddressContext?.handleCloseNewAutoDetectBottomSheet;
  const handleNewAutoDetectBottomSheetClick = newAddressContext?.handleNewAutoDetectBottomSheetClick;
  const handleCloseImportBottomSheet = newAddressContext?.handleCloseImportBottomSheet;
  const handleImportAddressClick = newAddressContext?.handleImportAddressClick;
  const showImportFailureToast = newAddressContext?.showImportFailureToast;
  const setShowImportFailureToast = newAddressContext?.setShowImportFailureToast;
  const handleAddManuallyFromNewAutoDetectBottomSheet = newAddressContext?.handleAddManuallyFromNewAutoDetectBottomSheet;
  const handleAddManuallyFromImportBottomSheet = newAddressContext?.handleAddManuallyFromImportBottomSheet;
  const handleAddAddressManuallyClick = newAddressContext?.handleAddAddressManuallyClick;
  
  const autoDetectAddressRef = newAddressContext?.autoDetectAddressRef;
  const loadingParams = newAddressContext?.loadingParams;
  const scrollToErrorField = newAddressContext?.scrollToErrorField;
  const totalSaved = addressContext?.cartInfo?.totalSaved;
  const totalAddressCount = addressContext?.totalAddressCount;
  const addresses = addressContext?.addresses;
  const paymentOptionConfig = addressContext?.paymentOptionConfig;
  const selectedPaymentOption = addressContext?.selectedPaymentOption;
  const doPayment = addressContext?.handleDoPaymentFactory;
  const loading = addressContext?.loading;
  const setLoading = addressContext?.setLoading;
  const isPaymentBottomSheetVisisble = addressContext?.isPaymentBottomSheetVisisble;
  const setIsPaymentBottomSheetVisisble = addressContext?.setIsPaymentBottomSheetVisisble;
  const isPaymentFormAddressPageExpEnable = doCheckPaymentFromAddressPageExpEnable({
    experiment: PaymentFormAddressPage.experimentEnabled,
    orderAmount,
    addressCount: totalAddressCount,
    isGuest: isGuestUser
  })
  
  const {
    applicationData: { isBeautyPlatform, isApp },
  } = applicationContext;

  const [newAddressLoading, setNewAddressLoading] = useState(true);
  const [showBackFrictionBottomSheet, setShowBackFrictionBottomSheet] = useState(false);
  const [addressBackFrictionExpEnable, setAddressBackFrictionExpEnable] = useState(false);
  const [buttonBottom, setButtonBottom] = useState(0); // Distance of the button from the bottom

  const loadGoogleMapsAPI = () => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GEO_LOCATION_API_KEY}`;
    script.async = true;
    document.head.appendChild(script);
  };
  useEffect(() => {
    loadGoogleMapsAPI();
    setNewAddressLoading(false);
  }, []);

  useMemo(() => {
    if (scrollToErrorField) {
      if (formError.pinCode.hasError || formError.house.hasError || formError.area.hasError) {
        if (!isServer()) {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      } else if (formError.name.hasError) {
        (nameRef?.current as any)?.scrollIntoView({ behavior: "smooth" });
      } else if (formError.phone.hasError) {
        (phoneRef?.current as any)?.scrollIntoView({ behavior: "smooth" });
      } else if (formError.email.hasError) {
        (emailRef?.current as any)?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [formError, scrollToErrorField]);

  /**
   * function to get backfriction data.
   */
  const backFrictionData = useMemo(
    () =>
      getBackFrictionData(
        theme,
        totalSaved,
        (value: boolean) => {
          /**
           * if user closing bottom sheet then we are removing #disable back from url
           * as we are showing address back friction bottom sheet once per session if
           * backfriction session exp is enable else we are showing bottom sheet everytime
           * when user press back.
           */
          if (!value && AddressPageBackFrictionWithSession?.experimentEnabled) {
            history.goBack();
          }
          setShowBackFrictionBottomSheet(value);
        },
        trackContinuewithPaymentClick,
        trackCancelPaymentClick,
        platform,
        AddressPageBackFriction?.experimentEnabled ||
          AddressPageBackFrictionWithSession?.experimentEnabled,
        isApp
      ),
      /* eslint-disable react-hooks/exhaustive-deps */
    [theme, totalSaved]
  );
  const mobileBackFrictionConfig = backFrictionData?.addressPageConfig;

  /**
   * NOTE: This code is special as it solves all back button issues
   * This code provides the functionality to do some action before going back to previous navigation url or browser history url.
   * Here: On click of browser back button , it should work the as same as work in application header back button.
   */
   useEffect(() => {
     /**
      * This will show only if it’s a first time user or guest user, not for repeat users.
      * showing this back friction once per session
      */
     const isAddressBackBottomSheetAlreadyLoads = getStorageData(
       TRACKING_EVENTS.ADDRESS_BACK_BOTTOMSHEET_LOADS,
       false
     );

     const isAddressBackFrictionExpEnable =
       (AddressPageBackFriction?.experimentEnabled ||
         AddressPageBackFrictionWithSession?.experimentEnabled) &&
       !addressContext?.cartInfo?.shippingAddress &&
       addresses.length === 0 &&
       !isAddressBackBottomSheetAlreadyLoads;

     setAddressBackFrictionExpEnable(isAddressBackFrictionExpEnable);

     /**
      * if url has not hash value and exp is enable then pushing #disableback in url.
      */

     if (history.location.hash !== "#disableBack" && isAddressBackFrictionExpEnable) {
       history.push("#disableBack");
     }

     const unblock = history.block((_location, action: string) => {
       if (action == "POP") {
         if (
           !showBackFrictionBottomSheet &&
           history.location.hash === "#disableBack" &&
           isAddressBackFrictionExpEnable
         ) {
           /**
            * tracking event for address backFriction.
            */
           trackAddressBackFrictionLoads();
           allTrackingHandlerForApps({
             event: TRACKING_EVENTS.ADDRESS_BACK_BOTTOMSHEET_LOADS,
             isApp,
           });

           /**
            * setting ADDRESS_BACK_BOTTOMSHEET_LOADS in session if session
            * backfriction exp enable
            */
           if (AddressPageBackFrictionWithSession?.experimentEnabled) {
             setStorage({ key: TRACKING_EVENTS.ADDRESS_BACK_BOTTOMSHEET_LOADS, data: "true" });
           }

           setShowBackFrictionBottomSheet(true);
           return false;
         }
       }
       return;
     });

     return () => {
       unblock();
     };
   }, [history, showBackFrictionBottomSheet, addresses.length]);

  useEffect(() => { 
    /**
     * Objective of this block: Save and pay button on address page is hidden behind keyboard when user enter password.
     * interactive-widget=resizes-content is available on chrome which handles the resizing of viewport automatically when keyboard is opened.
     * This gives us floating save and pay button on address page making it convinient for user to click this CTA.
     */
    if (isNewAddressDesignEnabled) {    
      // Find the meta tag with name="viewport"
      const metaViewport = document.querySelector('meta[name="viewport"]');
      let originalContent = "";

      if (metaViewport) {
        // Store the original content
        originalContent = metaViewport.getAttribute("content") || "";

        // Check if "interactive-widget=resizes-content" is already appended
        if (!originalContent.includes("interactive-widget=resizes-content")) {
          // Append "interactive-widget=resizes-content" to the content
          metaViewport.setAttribute(
            "content",
            `${originalContent}, interactive-widget=resizes-content`
          );
        }
      }
      // Cleanup on component unmount
      return () => {
        if (metaViewport) {
          metaViewport.setAttribute("content", originalContent);
        }
      };
    }
  }, []);
  
  if (addressContext?.addressLoading || newAddressLoading) {
    return <SelectedAddressLoader />;
  }

  return (
    <div>
      <Wrapper>
        <MobHeader
          title={headerTitle}
          onIconClick={handleBackButton}
          extraClass = {isPaymentBottomSheetVisisble ? "zIndexZero" : ""}
          fixAtTop
          dataTestId="back_button"
        />
        
        <Main className="layout vertical">
          <div className="layout vertical flex-2" data-testid="address-form">
            <MsgCard
              extraClass="mtb16 mrl20 new-msg-card"
              message={genericMessage}
              type={genericMessageType}
              dataTestId="txt_info_message_address_page"
            />
            <AddressFormStyle>
              <div className="layout pt8 horizontal justified">
                {!isNewAddressDesignEnabled && (
                  <h2 className="prl20 font-semibold heading">
                    {vernacularMessages.title || NEW_ADDRESS_DEFAULT_MESSAGE.ADDRESS}
                  </h2>
                )}
                {/**
                 * showing the auto detect icon incase of webview or
                 * incase of mweb and deweb showing based on remoteConfig switch in detected city component
                 */
                isAutoDetectLocationEnabled && isApp && (
                  <BasicButtonWithIcon
                    className="layout horizontal center-center auto-detect-btn"
                    type="button"
                    onClick={getCurrentGeoLocation}
                  >
                    <span className="mr5 text-brand-color">
                      {vernacularMessages.autoDetectLocation ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.AUTO_DETECT}
                    </span>
                    <Image
                      url={getIcons(platform, ICONS_NAMES.AUTO_DETECT)}
                      alt={"Auto Detect"}
                      theme={theme}
                    />
                  </BasicButtonWithIcon>
                )}
              </div>
              <div className="layout vertical pt8 prl20">
                {isNewAddressDesignEnabled && (
                  <DetectedCity
                    detectingCity={isUserEditingPincode}
                    fetchingGeoLocation={fetchingGeoLocation}
                    errorFetchingGeoLocation={errorFetchingGeoLocation}
                    detectedCity={addressForm.city}
                    detectedState={addressForm.state}
                    locationSecondaryText={NEW_ADDRESS_DEFAULT_MESSAGE.LOCATION_AUTO_DETECTED}
                    pinCode={addressForm.pinCode}
                    platform={platform}
                    errorState={formError.pinCode.error}
                    isAutoDetectLocationEnabled={isAutoDetectLocationEnabled}
                    getCurrentGeoLocation={getCurrentGeoLocation}
                  />
                )}
                <NewFormStyle isNewAddressDesignEnabled={isNewAddressDesignEnabled} />
                <div
                  className={`input-wrapper pos-relative ${
                    formError.pinCode.hasError ? "expand-input" : ""
                  }`}
                  ref={el => (autoDetectAddressRef.current.pinCode = el)}
                >
                  {/* eslint-disable jsx-a11y/no-autofocus */}
                  <InputField
                    ref={(el: HTMLDivElement) => (autoDetectAddressRef.current.pinCode = el)}
                    type="tel"
                    onChange={(pincode: string | number | null) =>
                      handleInputChange(pincode, FORM_FIELD.PINCODE)
                    }
                    labelText={
                      vernacularMessages.pinCodeLabel || NEW_ADDRESS_DEFAULT_MESSAGE.PINCODE
                    }
                    value={addressForm.pinCode}
                    errorText={formError.pinCode.error}
                    onBlur={handlePinCodeBlur}
                    required={true}
                    theme={theme}
                    dataTestId="txt_pincode"
                    autoCompleteOff={false}
                    autoComplete={"postal-code"}
                    id={"pinCode"}
                    errorDataTestId="msg_non_serviceable"
                    placeHolderText={FORM_FIELD_PLACEHOLDER.PINCODE}
                    autoFocus={
                      !(isAutoDetectLocationBottomSheetEnabled && showNewDetectLocationBottomSheet)
                    }
                  />
                </div>
                {!isNewAddressDesignEnabled && (
                  <div
                    className={`layout horizontal justified ${
                      addressForm.city ? "" : "hidden-layer"
                    } `}
                  >
                    <div className="input-wrapper split-input mr5 pos-relative">
                      <InputField
                        onChange={() => {}}
                        type="text"
                        labelText={vernacularMessages.cityLabel || NEW_ADDRESS_DEFAULT_MESSAGE.CITY}
                        value={addressForm.city}
                        required={true}
                        disabled={true}
                        theme={theme}
                        dataTestId={"txt_city_name"}
                      />
                    </div>
                    <div className="input-wrapper split-input ml5 pos-relative">
                      <InputField
                        onChange={() => {}}
                        type="text"
                        labelText={
                          vernacularMessages.stateLabel || NEW_ADDRESS_DEFAULT_MESSAGE.STATE
                        }
                        value={addressForm.state}
                        required={true}
                        disabled={true}
                        theme={theme}
                        dataTestId={"txt_state_name"}
                      />
                    </div>
                  </div>
                )}
                <div
                  className={`input-wrapper pos-relative ${
                    isEditing && isBeautyPlatform ? "hidden-layer" : ""
                  } ${formError.house.hasError ? "expand-input" : ""}`}
                  ref={el => (autoDetectAddressRef.current.houseNo = el)}
                >
                  <InputField
                    type="text"
                    onChange={(house: string | number | null) =>
                      handleInputChange(house, FORM_FIELD.HOUSE)
                    }
                    labelText={
                      vernacularMessages.houseLabel || NEW_ADDRESS_DEFAULT_MESSAGE.HOUSE_LABEL
                    }
                    value={addressForm.house}
                    errorText={formError.house.error}
                    onBlur={() => handleInputBlur(FORM_FIELD.HOUSE)}
                    required={true}
                    theme={theme}
                    maxLength={50}
                    dataTestId="txt_house"
                    autoCompleteOff={false}
                    autoComplete={"address-line1"}
                    id={"addressLine1"}
                    placeHolderText={FORM_FIELD_PLACEHOLDER.HOUSE}
                  />
                </div>
                <div
                  className={`input-wrapper pos-relative ${
                    formError.area.hasError ? "expand-input" : ""
                  }`}
                  ref={el => (autoDetectAddressRef.current.area = el)}
                >
                  <TextAreaField
                    ref={areaRef}
                    labelText={
                      vernacularMessages.areaLabel || NEW_ADDRESS_DEFAULT_MESSAGE.AREA_LABEL
                    }
                    cols={30}
                    rows={4}
                    value={addressForm.area}
                    errorText={formError.area.error}
                    onChange={(value: string | number | null) => {
                      handleInputChange(value, FORM_FIELD.AREA);
                    }}
                    onBlur={() => handleInputBlur(FORM_FIELD.AREA)}
                    required
                    theme={theme}
                    maxLength={120}
                    dataTestId="txt_area"
                    errorDataTestId="msg_address_txtarea"
                    placeHolderText={FORM_FIELD_PLACEHOLDER.AREA}
                  />
                </div>
              </div>
              {!isGuestUser && !isNewAddressDesignEnabled && (
                <div className="layout horizontal pt8 pb16 prl20 justified">
                  <span className="font-size-16 center-center flex-grow">
                    {vernacularMessages.useAsDefaultAddress ||
                      NEW_ADDRESS_DEFAULT_MESSAGE.USE_AS_DEFAULT_ADDRESS}
                  </span>
                  <ToggleSwitch
                    isChecked={addressForm.isDefaultOptionChecked}
                    onToggle={handleDefaultAddressToggle}
                    dataTestId={"save_address_checkbox"}
                  />
                </div>
              )}
              {isNewAddressDesignEnabled && !isGuestUser && (
                <>
                  {isGuestUser || !totalAddressCount ? (
                    <div className="layout vertical">
                      <div className="layout horizontal pb16 prl20 justified">
                        <Text
                          text={
                            vernacularMessages.savedAsPrimaryAddress ||
                            NEW_ADDRESS_DEFAULT_MESSAGE.SAVED_AS_PRIMARY_ADDRESS
                          }
                          font={theme.typography.bodySmall}
                          theme={theme}
                          color={getHexToRgba(theme.colors.textPrimary, 0.64)}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="layout vertical">
                      <div className="layout horizontal pb16 prl20 justified">
                        <Text
                          text={
                            vernacularMessages.useAsPrimaryAddress ||
                            NEW_ADDRESS_DEFAULT_MESSAGE.USE_AS_PRIMARY_ADDRESS
                          }
                          font={theme.typography.bodyMedium}
                          theme={theme}
                          color={getHexToRgba(theme.colors.textPrimary, 0.92)}
                        />
                        <div
                          data-testId={"save_address_checkbox_wrapper"}
                          onClick={event => {
                            event?.preventDefault();
                            handleDefaultAddressToggle();
                          }}
                        >
                          <CheckBox
                            isChecked={addressForm.isDefaultOptionChecked}
                            borderRadius={4}
                            dataTestId={"save_address_checkbox"}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              {isNewAddressDesignEnabled && (
                <div className="layout vertical">
                  <HorizonalSeprator></HorizonalSeprator>
                </div>
              )}
              {!isNewAddressDesignEnabled && (
                <h1 className="pt12 prl20 font-semibold heading">
                  {vernacularMessages.contactTitle || NEW_ADDRESS_DEFAULT_MESSAGE.CONTACT}
                </h1>
              )}
              <div className="layout vertical ptb8 prl20">
                <div
                  className={`input-wrapper pos-relative ${
                    formError.name.hasError ? "expand-input" : ""
                  }`}
                  ref={el => (autoDetectAddressRef.current.name = el)}
                >
                  <InputField
                    ref={nameRef}
                    type="text"
                    onChange={(name: string | number | null) =>
                      handleInputChange(name, FORM_FIELD.NAME)
                    }
                    labelText={vernacularMessages.nameLabel || NEW_ADDRESS_DEFAULT_MESSAGE.NAME}
                    value={addressForm.name}
                    errorText={formError.name.error}
                    onBlur={() => handleInputBlur(FORM_FIELD.NAME)}
                    required={true}
                    theme={theme}
                    inputIcon={CloseCircleIcon}
                    onFocus={nameInputIconVisible}
                    isInputIconVisible={nameInputIcon}
                    onInputIconClick={clearInputField}
                    dataTestId="txt_name"
                    autoCompleteOff={false}
                    autoComplete={"name"}
                    id={"name"}
                    errorDataTestId="msg_field_name"
                    placeHolderText={FORM_FIELD_PLACEHOLDER.NAME}
                  />
                </div>
                <div
                  className={`input-wrapper pos-relative ${
                    formError.phone.hasError ? "expand-input" : ""
                  }`}
                  ref={el => (autoDetectAddressRef.current.phone = el)}
                >
                  <InputField
                    ref={phoneRef}
                    type="tel"
                    onChange={(phone: string | number | null) =>
                      handleInputChange(phone, FORM_FIELD.PHONE)
                    }
                    labelText={vernacularMessages.phoneLabel || NEW_ADDRESS_DEFAULT_MESSAGE.PHONE}
                    value={addressForm.phone}
                    errorText={formError.phone.error}
                    onBlur={() => handleInputBlur(FORM_FIELD.PHONE)}
                    required={true}
                    theme={theme}
                    inputIcon={CloseCircleIcon}
                    onFocus={phoneInputIconVisible}
                    isInputIconVisible={phoneInputIcon}
                    onInputIconClick={clearPhoneInputField}
                    dataTestId="txt_phone"
                    autoCompleteOff={false}
                    autoComplete={"phone"}
                    id={"phoneNumber"}
                    errorDataTestId="msg_field_phone"
                    placeHolderText={FORM_FIELD_PLACEHOLDER.PHONE}
                  />
                </div>
                <div 
                  className="input-wrapper pos-relative"
                  ref={el => (autoDetectAddressRef.current.email = el)}
                >
                  {!hideEmail && (
                    <InputField
                      ref={emailRef}
                      type="email"
                      onChange={(email: string | number | null) =>
                        handleInputChange(email, FORM_FIELD.EMAIL)
                      }
                      labelText={vernacularMessages.emailLabel || NEW_ADDRESS_DEFAULT_MESSAGE.EMAIL}
                      value={addressForm.email}
                      errorText={formError.email.error}
                      onBlur={() => handleInputBlur(FORM_FIELD.EMAIL)}
                      required={true}
                      theme={theme}
                      inputIcon={CloseCircleIcon}
                      onFocus={emailInputIconVisible}
                      isInputIconVisible={emailInputIcon}
                      onInputIconClick={clearEmailInputField}
                      dataTestId="txt_email"
                      autoCompleteOff={false}
                      autoComplete={"email"}
                      id={"email"}
                      errorDataTestId="msg_field_email"
                      placeHolderText={FORM_FIELD_PLACEHOLDER.EMAIL}
                    />
                  )}
                </div>
                {isNewAddressDesignEnabled ? (
                  <TrustNote className="layout horizontal ptb16 justified trust-note">
                    <Text
                      text={
                        vernacularMessages.privacyNoteNew ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.PRIVACY_NOTE_NEW
                      }
                      font={theme.typography.bodySmall}
                      theme={theme}
                      color={getHexToRgba(theme.colors.textPrimary, 0.64)}
                    />
                    <Icon icon={getIcons(platform, ICONS_NAMES.PRIVACY_ICON)} />
                  </TrustNote>
                ) : (
                  <div className="layout horizontal ptb16 prl120 justified trust-note">
                    <p className="ptb16 prl20 cred-text-note font-size-12">
                      {vernacularMessages.privacyNote || NEW_ADDRESS_DEFAULT_MESSAGE.PRIVACY_NOTE}
                    </p>
                    <LockIcon />
                  </div>
                )}
                <div className="bottom-fixed ptb16 prl20">

                  {isPaymentFormAddressPageExpEnable && (
                    <AddressPaymentSection
                      isPaymentBottomSheetVisisble={isPaymentBottomSheetVisisble}
                      setIsPaymentBottomSheetVisisble={setIsPaymentBottomSheetVisisble}
                      addressForm={addressForm}
                      onSubmit={onSubmit}
                      paymentOptionConfig={paymentOptionConfig[selectedPaymentOption]}
                      paymentInfo={paymentInfo}
                      isGuest={isGuestUser}
                      loading={loading}
                      setLoading={setLoading}
                      totalSaved={Math.round(totalSaved)}
                      cartInfo={cartInfo}
                      orderAmount={orderAmount}
                      doPayment={doPayment}
                    />
                  )}
                  
                  <FilledButton
                    text={submitButtonTitle}
                    onClick={onSubmit}
                    theme={theme}
                    dataTestId="button_shipToThisAddress"
                  />
                </div>
              </div>
              {
                showPermissionToast && (
                  <ToastLayout>
                    <Toast
                      hideTimer={true}
                      message={vernacularMessages.locationPermissionText || NEW_ADDRESS_DEFAULT_MESSAGE.LOCATION_PERMISSION_TEXT}
                      onDismiss={() => setShowPermissionToast(false)}
                      variant="single"
                      verticalOffset={90}
                      isChildren={false}
                    >
                    </Toast>
                  </ToastLayout>
                )
              }
              {
                showImportFailureToast && (
                  <ToastLayout>
                    <Toast
                      hideTimer={true}
                      message={vernacularMessages.importErrorText}
                      onDismiss={() => setShowImportFailureToast(false)}
                      variant="single"
                      verticalOffset={90}
                      isChildren={false}
                    >
                    </Toast>
                  </ToastLayout>
                )
              }
            </AddressFormStyle>
          </div>
        </Main>

        {/* Auto Detect Bottom sheet with Detect Location Automatocally button */}
        {/* Auto Detect Bottom sheet */}
        <BottomSheet
          isVisible={showAutoDetectBottomSheet}
          leadingIcon={getIcons(platform, ICONS_NAMES.ADDRESS_CLEAR)}
          onClose={() => handleCloseAutoDetectBottomSheet(false)}
          onIconClick={() => handleCloseAutoDetectBottomSheet(false)}
          theme={theme}
          history={history}
          maxHeight={32}
        >
          <>
            <BottomSheetWrapper>
              <Title
                text={
                  vernacularMessages.autoDetectBottomSheetTitle ||
                  NEW_ADDRESS_DEFAULT_MESSAGE.AUTO_DETECT_BOTTOMSHEET_TITLE
                }
                font={theme.typography.titleLarge}
                color={theme.colors.textPrimary}
              />
              <SubtitleWrapper>
                <SubTitle
                  text={autoDetectBottomSheetSubtitle || ""}
                  font={theme.typography.bodyLarge}
                  color={getHexToRgba(theme.colors.pebble900, 0.92)}
                />
              </SubtitleWrapper>
              <ButtonWrapper>
                <ContainedButton
                  text={NEW_ADDRESS_DEFAULT_MESSAGE.EDIT}
                  onClick={() => handleSuccessAutoDetectBottomSheet(true)}
                />
                <FilledButton
                  text={NEW_ADDRESS_DEFAULT_MESSAGE.CONFIRM}
                  onClick={() => handleSuccessAutoDetectBottomSheet(false)}
                />
              </ButtonWrapper>
            </BottomSheetWrapper>
          </>
        </BottomSheet>

        {/* Back Bottom sheet */}
        <BottomSheet
          isVisible={isBottomSheetVisible}
          leadingIcon={getIcons(platform, ICONS_NAMES.ADDRESS_CLEAR)}
          onClose={handleCloseBottomModal}
          onIconClick={handleCloseBottomModal}
          theme={theme}
          maxHeight={85}
          dataTestId="lb_confirm_bottomsheet"
        >
          <>
            <BottomSheetWrapper>
              <Title
                text={
                  vernacularMessages.bottomSheetTitle ||
                  NEW_ADDRESS_DEFAULT_MESSAGE.BOTTOM_SHEET_TITLE
                }
                font={theme.typography.titleLarge}
                color={theme.colors.textPrimary}
              />
              <SubtitleWrapper>
                <SubTitle
                  text={
                    vernacularMessages.bottomSheetContent ||
                    NEW_ADDRESS_DEFAULT_MESSAGE.BOTTOM_SHEET_CONTENT
                  }
                  font={theme.typography.bodyLarge}
                  color={getHexToRgba(theme.colors.pebble900, 0.92)}
                />
              </SubtitleWrapper>
              <ButtonWrapper>
                <ContainedButton
                  text={
                    vernacularMessages.cancelButtonTitle ||
                    NEW_ADDRESS_DEFAULT_MESSAGE.BOTTOM_SHEET_CANCEL
                  }
                  onClick={() => handleDontSaveClick(addressBackFrictionExpEnable)}
                  dataTestId="btn_donot_save_address_changes"
                />
                <FilledButton
                  text={
                    vernacularMessages.successButtonTitle ||
                    NEW_ADDRESS_DEFAULT_MESSAGE.BOTTOM_SHEET_SUCCESS
                  }
                  onClick={handleSaveChangesClick}
                  dataTestId="btn_save_address_changes"
                />
              </ButtonWrapper>
            </BottomSheetWrapper>
          </>
        </BottomSheet>

        {/* Pincode Bottom sheet */}
        <BottomSheet
          isVisible={isPincodeBottomSheetVisible}
          icon={getIcons(platform, ICONS_NAMES.CLEAR)}
          onClose={onPincodeBottomSheetClose}
          onIconClick={onPincodeBottomSheetClose}
          theme={theme}
          history={history}
          maxHeight={85}
          dataTestId="lb_confirm_bottomsheet"
        >
          <>
            <Title
              text={pincodeBottomSheetTitle}
              font={theme.typography.titleLarge}
              dataTestId="txt_non_Serviceable_pincode"
            />
            <PincodeBottomSheetContent
              text={pincodeBottomSheetSubTitle}
              dismissButtonText={pincodeBottomSheetActionButtonText}
              onDismiss={onPincodeBottomSheetClose}
              font={theme.typography.bodyMedium}
              dismissButtonDataTestId="btn_got_it"
            />
          </>
        </BottomSheet>
        {/* Import Address Bottom sheet */}
        {
          isImportAddressEnabled && showImportAddressBottomSheet && (
            <BottomSheet
              isVisible={showImportAddressBottomSheet}
              leadingIcon={getIcons(platform, ICONS_NAMES.CLEAR)}
              onClose={handleCloseImportBottomSheet}
              onIconClick={handleCloseImportBottomSheet}
              isNewBottomSheetDesign={true}
              bannerUrl={getIcons(platform, ICONS_NAMES.AUTO_DETECT_BANNER)}
              theme={theme}
              maxHeight={85}
              dataTestId="import_address"
            >
              <>
                <NewBottomSheetWrapper>
                  <div className="new-bottom-sheet-title">
                    <Title
                      text = {
                        vernacularMessages.importAddressBottomSheetTitle ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.IMPORT_ADDRESS_BOTTOM_SHEET_TITLE
                      }
                      font={theme.typography.titleMedium}
                      color={getHexToRgba(theme.colors.textPrimary, 0.92)}
                    />
                  </div>
                  <div className="new-bottom-sheet-sub-title">
                    <SubTitle
                      text = {
                        vernacularMessages.importAddressBottomSheetSubTitle ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.IMPORT_ADDRESS_BOTTOM_SHEET_SUB_TITLE
                      }
                      font={theme.typography.subTitleMedium}
                      color={getHexToRgba(theme.colors.textPrimary, 0.64)}
                    />
                  </div>
                  <div className="horizontal-separator"></div>
                  <div className="new-button-wrapper">
                    <ContainedButton
                      text = {
                        vernacularMessages.addManuallyBtn ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.ADD_MANUALLY_BTN
                      }
                      onClick={handleAddManuallyFromImportBottomSheet}
                      dataTestId="btn_add_manually"
                    />
                    <FilledButton
                      text = {
                        vernacularMessages.importButtonText ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.IMPORT_BUTTON_TEXT
                      }
                      onClick={handleImportAddressClick}
                      dataTestId="btn_import_address"
                    />
                  </div>
                </NewBottomSheetWrapper>
              </>
            </BottomSheet>
          ) 
        }
        {/* Auto Detect Bottom sheet with Detect Location Automatically button 
          * If both import and auto detetect bottom sheet are eligible then only import bottom sheet is shown
        */}
        {isAutoDetectLocationEnabled &&
          isAutoDetectLocationBottomSheetEnabled &&
          isNewAddressDesignEnabled && !(isImportAddressEnabled && showImportAddressBottomSheet) && (
            <BottomSheet
              isVisible={showNewDetectLocationBottomSheet}
              leadingIcon={getIcons(platform, ICONS_NAMES.CLEAR)}
              isNewBottomSheetDesign={true}
              bannerUrl={getIcons(platform, ICONS_NAMES.AUTO_DETECT_BANNER)}
              onClose={handleCloseNewAutoDetectBottomSheet}
              onIconClick={handleCloseNewAutoDetectBottomSheet}
              theme={theme}
              maxHeight={85}
              dataTestId="auto_detect_location"
            >
              <>
                <NewBottomSheetWrapper>
                  <div className="new-bottom-sheet-title">
                    <Title
                      text = {
                        vernacularMessages.newAutoDetectBottomSheetTitle ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.NEW_AUTO_DETECT_BOTTOM_SHEET_TITLE
                      }
                      font={theme.typography.titleMedium}
                      color={getHexToRgba(theme.colors.textPrimary, 0.92)}
                    />
                  </div>
                  <div className="new-bottom-sheet-sub-title">
                    <SubTitle
                      text={
                        vernacularMessages.newAutoDetectBottomSheetSubTitle ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.NEW_AUTO_DETECT_BOTTOM_SHEET_SUB_TITLE
                      }
                      font={theme.typography.subTitleMedium}
                      color={getHexToRgba(theme.colors.textPrimary, 0.64)}
                    />
                  </div>
                  <div className="horizontal-separator"></div>
                  <div className="new-button-wrapper">
                    <ContainedButton
                      text={
                        vernacularMessages.addManuallyBtn ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.ADD_MANUALLY_BTN
                      }
                      onClick={handleAddManuallyFromNewAutoDetectBottomSheet}
                      dataTestId="btn_add_manually"
                    />
                    <FilledButton
                      text={
                        vernacularMessages.detectLocationBtn ||
                        NEW_ADDRESS_DEFAULT_MESSAGE.DETECT_LOCATION_BTN
                      }
                      onClick={handleNewAutoDetectBottomSheetClick}
                      dataTestId="btn_detect_location"
                    />
                  </div>
                </NewBottomSheetWrapper>
              </>
            </BottomSheet>
          )}
      </Wrapper>
      <OverlayLoader isActive={isLoading} zIndex={2} loadingParams={loadingParams} />
      {showBackFrictionBottomSheet && (
        <BackFrictionBottomSheet {...mobileBackFrictionConfig} isHorizontalButtonGroup />
      )}
    </div>
  );
};

export default NewAddress;
